import * as React from "react";
import get from "lodash/get";

import "./UniqueEmailShareCount.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import {
  getIsLoadingShareCount,
  getShareCount,
} from "../../reducers/shareCount/methods";

export interface UniqueEmailShareCountProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  shareCount: ReturnType<typeof getShareCount>;
  isLoading: ReturnType<typeof getIsLoadingShareCount>;
}

export class UniqueEmailShareCount extends ComponentBase<UniqueEmailShareCountProps> {
  getClassNames = (props: UniqueEmailShareCountProps) => {
    const textClass = "UniqueEmailShareCount-text ";

    return textClass.concat(
      `UniqueEmailShareCount-mode-${props.mode || "default"} `,
      `${props.classNames || ""} `,
      `${!props.isEditing ? "UniqueEmailShareCount-text-preview" : ""} `,
      this.state.animationClass
    );
  };

  render() {
    const { style, shareCount, action, successScreen } = this.props;

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={this.getClassNames(this.props)}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {shareCount}
      </div>
    );
  }
}
